import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TGetGoldConversionAmountParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetGoldConversionAmount(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetGoldConversionAmountAttempt', handleGetGoldConversionAmount, api);
}

function* handleGetGoldConversionAmount(api: GoldGateway, data: PayloadAction<TGetGoldConversionAmountParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { productId, amount } = data.payload;

    if (!productId || !amount) {
        yield put(combinedActions.goldGetGoldConversionAmountFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getGoldConversionAmount], {
        authToken,
        productId,
        amount,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetGoldConversionAmountFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetGoldConversionAmountSuccess(Number(response.data)));
    }
}
